import React from 'react'
import s from './Checkout.module.scss'
import { ReactComponent as CheckMark } from 'images/new-icons/check-mark-big.svg'
import Button from 'components/shared/Button'
import { BasketSteps } from '../ShoppingCart'
import { useNavigate } from 'react-router-dom'

const Success = ({setStep}) => {
    const navigate = useNavigate()
    return (
        <div className={s.success}>
            <div className={s.success_top}>
                <CheckMark />
                <div className={s.success_top_title}>Your order has been successfully paid for</div>
            </div>
            <div>
                <Button wide purple onClick={()=>navigate('/feed')}>View Details</Button>
            </div>
        </div>
    )
}

export default Success